(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldSelectWithText', ['thfFieldHelper','$sce', function(thfFieldHelper, $sce) {
        var link = function(scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');
            scope.$watchGroup([
                'modal.'+scope.field.name
            ], function() {
                $('select', el).selectpicker('refresh');
            });
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/selectWithText.html');
            }
        };
    }]);
})(jQuery, angular, window);
